import {
  canCurrentUserSendOnBehalfOf,
  getAdalResourceForGraph,
  getAdalResourceForLoki,
  getAdalResourceForYammer,
  getAllowedUploadFileType,
  getBootstrapError,
  getBroadcastHost,
  getCurrentNetworkPermalink,
  getCurrentNetworkUsagePolicy,
  getCurrentNetworkUsagePolicyStatus,
  getCurrentNetworkUsagePolicyThrows,
  getCurrentSessionUser,
  getDesignerAppHost,
  getEditNetworkUsagePolicyStatus,
  getLegacyHost,
  getMsalResourceForYammer,
  getNetworkPublisherSettingsStatus,
  getSharedSettings,
  getSubstrateConfig,
  getTenorHost,
  getThumbnailsHost,
  getWebHost,
  isAllCompanyGroupMigrated,
  isCurrentNetworkNativeModeSharePointOnlyFileStorage,
  isCurrentNetworkOfficeTopicsEnabled,
  isCurrentNetworkPushNotificationsEnabled,
  isDirectMessagesEnabled,
  isDraftPostsEnabled,
  isForcedNotificationEnabled,
  isGifShortcutEnabledInNetwork,
} from '@ms/yammer-data/dist/domains/session/selectors';
import { getHostFromUrl } from '@ms/yammer-web-support/dist/urls';

import { useSelector } from '../useSelector';

type UseCurrentSessionUser = () => ReturnType<typeof getCurrentSessionUser>;
export const useCurrentSessionUser: UseCurrentSessionUser = () => useSelector(getCurrentSessionUser);

type UseCanCurrentUserSendOnBehalfOf = () => ReturnType<typeof canCurrentUserSendOnBehalfOf>;
export const useCanCurrentUserSendOnBehalfOf: UseCanCurrentUserSendOnBehalfOf = () =>
  useSelector(canCurrentUserSendOnBehalfOf);

type UseAdalResourceForYammer = () => ReturnType<typeof getAdalResourceForYammer>;
export const useAdalResourceForYammer: UseAdalResourceForYammer = () => useSelector(getAdalResourceForYammer);

type UseMsalResourceForYammer = () => ReturnType<typeof getMsalResourceForYammer>;
export const useMsalResourceForYammer: UseMsalResourceForYammer = () => useSelector(getMsalResourceForYammer);

type UseAdalResourceForLoki = () => ReturnType<typeof getAdalResourceForLoki>;
export const useAdalResourceForLoki: UseAdalResourceForLoki = () => useSelector(getAdalResourceForLoki);

type UseAdalResourceForGraph = () => ReturnType<typeof getAdalResourceForGraph>;
export const useAdalResourceForGraph: UseAdalResourceForGraph = () => useSelector(getAdalResourceForGraph);

type UseBaseHost = () => ReturnType<typeof getWebHost>;
export const useBaseHost: UseBaseHost = () => useSelector(getWebHost);

type UseWebHostName = () => ReturnType<typeof getWebHost>;
export const useWebHostName: UseWebHostName = () => {
  const webHost = useBaseHost();
  const host = getHostFromUrl(webHost);

  return host;
};

type UseBroadcastHost = () => ReturnType<typeof getBroadcastHost>;
export const useBroadcastHost: UseBroadcastHost = () => useSelector(getBroadcastHost);

type UseLegacyHost = () => ReturnType<typeof getLegacyHost>;
export const useLegacyHost: UseLegacyHost = () => useSelector(getLegacyHost);

type UseThumbnailsHost = () => ReturnType<typeof getThumbnailsHost>;
export const useThumbnailsHost: UseThumbnailsHost = () => useSelector(getThumbnailsHost);

type UseTenorHost = () => ReturnType<typeof getTenorHost>;
export const useTenorHost: UseTenorHost = () => useSelector(getTenorHost);

type UseSubstrateConfig = () => ReturnType<typeof getSubstrateConfig>;
export const useSubstrateConfig: UseSubstrateConfig = () => useSelector(getSubstrateConfig);

type UseCurrentNetworkPermalink = () => ReturnType<typeof getCurrentNetworkPermalink>;
export const useCurrentNetworkPermalink: UseCurrentNetworkPermalink = () => useSelector(getCurrentNetworkPermalink);

type UseCurrentNetworkUsagePolicy = () => ReturnType<typeof getCurrentNetworkUsagePolicy>;
export const useCurrentNetworkUsagePolicy: UseCurrentNetworkUsagePolicy = () =>
  useSelector(getCurrentNetworkUsagePolicy);

type UseEditNetworkUsagePolicyStatus = () => ReturnType<typeof getEditNetworkUsagePolicyStatus>;
export const useEditNetworkUsagePolicyStatus: UseEditNetworkUsagePolicyStatus = () =>
  useSelector(getEditNetworkUsagePolicyStatus);

type UseGetNetworkPublisherSettingsStatus = () => ReturnType<typeof getNetworkPublisherSettingsStatus>;
export const useGetNetworkPublisherSettingsStatus: UseGetNetworkPublisherSettingsStatus = () =>
  useSelector(getNetworkPublisherSettingsStatus);

type UseCurrentNetworkUsagePolicyThrows = () => ReturnType<typeof getCurrentNetworkUsagePolicyThrows>;
export const useCurrentNetworkUsagePolicyThrows: UseCurrentNetworkUsagePolicyThrows = () =>
  useSelector(getCurrentNetworkUsagePolicyThrows);

type UseIsCurrentNetworkOfficeTopicsEnabled = () => ReturnType<typeof isCurrentNetworkOfficeTopicsEnabled>;
export const useIsCurrentNetworkOfficeTopicsEnabled: UseIsCurrentNetworkOfficeTopicsEnabled = () =>
  useSelector(isCurrentNetworkOfficeTopicsEnabled);

type UseIsCurrentNetworkPushNotificationsEnabled = () => ReturnType<typeof isCurrentNetworkOfficeTopicsEnabled>;
export const useIsCurrentNetworkPushNotificationsEnabled: UseIsCurrentNetworkPushNotificationsEnabled = () =>
  useSelector(isCurrentNetworkPushNotificationsEnabled);

type UseIsDirectMessagesEnabled = () => ReturnType<typeof isDirectMessagesEnabled>;
export const useIsDirectMessagesEnabled: UseIsDirectMessagesEnabled = () => useSelector(isDirectMessagesEnabled);

type UseIsDraftPostsEnabled = () => ReturnType<typeof isDraftPostsEnabled>;
export const useIsDraftPostsEnabled: UseIsDraftPostsEnabled = () => useSelector(isDraftPostsEnabled);

type UseIsCurrentNetworkForcedNotificationEnabled = () => ReturnType<typeof isCurrentNetworkOfficeTopicsEnabled>;
export const useIsCurrentNetworkForcedNotificationEnabled: UseIsCurrentNetworkForcedNotificationEnabled = () =>
  useSelector(isForcedNotificationEnabled);

type UseStatus = () => ReturnType<typeof getCurrentNetworkUsagePolicyStatus>;
export const useStatus: UseStatus = () => useSelector(getCurrentNetworkUsagePolicyStatus);

type UseBootstrapError = () => ReturnType<typeof getBootstrapError>;
export const useBootstrapError: UseBootstrapError = () => useSelector(getBootstrapError);

type UseIsGifShortcutEnabledInNetwork = () => ReturnType<typeof isGifShortcutEnabledInNetwork>;
export const useIsGifShortcutEnabledInNetwork: UseIsGifShortcutEnabledInNetwork = () =>
  useSelector(isGifShortcutEnabledInNetwork);

type UseAllowedUploadFileType = () => ReturnType<typeof getAllowedUploadFileType>;
export const useAllowedUploadFileType: UseAllowedUploadFileType = () => useSelector(getAllowedUploadFileType);

type UseIsAllCompanyGroupMigrated = () => ReturnType<typeof isAllCompanyGroupMigrated>;
export const useIsAllCompanyGroupMigrated: UseIsAllCompanyGroupMigrated = () => useSelector(isAllCompanyGroupMigrated);

type UseDesignerAppHost = () => ReturnType<typeof getDesignerAppHost>;
export const useDesignerAppHost: UseDesignerAppHost = () => useSelector(getDesignerAppHost);

type UseSharedSettings = () => ReturnType<typeof getSharedSettings>;
export const useSharedSettings: UseSharedSettings = () => useSelector(getSharedSettings);

type UseIsCurrentNetworkNativeMode = () => ReturnType<typeof isCurrentNetworkNativeModeSharePointOnlyFileStorage>;
export const useIsCurrentNetworkNativeMode: UseIsCurrentNetworkNativeMode = () =>
  useSelector(isCurrentNetworkNativeModeSharePointOnlyFileStorage);
